import VehicleRegistrationTireHtml from './vehicle-registration.tire.html';

export function VehicleRegistrationTireDirective () : ng.IDirective {
  const directive : ng.IDirective = {
    restrict: 'E',
    scope   : {
      tire: '='
    },
    templateUrl: VehicleRegistrationTireHtml
  };

  return directive;
}